import { Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';

import { disabledFormInputStyles } from '@Components/Form/styles';
import { FormTextEditor } from '@Components/Form';
import Flex from '@Components/Bases/Flex';

import { StakeholderAnalysisFormValues } from '../../ImpactsOnStakeholdersFormProvider/types';

const ExplanationOfBusinessValueChain = () => {
  const { completedSection } =
    useWatch({
      name: 'stakeholderAnalysis',
    }) ?? ({} as StakeholderAnalysisFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <Flex flexDirection={'column'} gap={2} mt={2}>
      <Typography fontWeight={700}>
        คำอธิบายเพิ่มเติมเรื่องห่วงโซ่ธุรกิจ (ถ้ามี)
      </Typography>
      <FormTextEditor
        name="stakeholderAnalysis.additionalDescriptionTh"
        inputProps={{ placeholder: 'กรุณาระบุ (ไทย)' }}
        label="กรุณาอธิบาย (ไทย) (ถ้ามี)"
        sx={isCompletedTh ? disabledFormInputStyles : undefined}
      />
      <FormTextEditor
        name="stakeholderAnalysis.additionalDescriptionEn"
        inputProps={{ placeholder: 'กรุณาระบุ (อังกฤษ)' }}
        label="กรุณาอธิบาย (อังกฤษ) (ถ้ามี)"
        sx={isCompletedEn ? disabledFormInputStyles : undefined}
      />
    </Flex>
  );
};

export default ExplanationOfBusinessValueChain;
